// -- import * as _ from "lodash-es"
import * as api from "../../shared/api"
import * as biz_data_helper from "../../shared/biz_data_helper"

const content_type = ""

const create = function () {
  return {
    content_type: "muji",
    age: 29
  }
}
const fields = {
  default: [
    {
      key: "id",
      label: "编号",
      sortable: true,
      thStyle: {
        width: "60px"
      }
    },
    {
      key: "ForecastSalesId",
      label: "平台预测订单编码",
      sortable: true
    },
    {
      key: "dataAreaId",
      label: "销售公司",
      sortable: true
    },
    {
      key: "CompanyName",
      label: "销售公司名称",
      sortable: true,
      thStyle: { width: "8rem" },
      width: "8rem",
      type: "short"
    },
    {
      key: "CustAccountId",
      label: "客户帐户",
      sortable: true
    },
    {
      key: "CustAccountName",
      label: "客户名称",
      sortable: true,
      thStyle: {
        width: "15rem"
      }
    },
    {
      key: "TEC_FinalCustAccount",
      label: "最终客户",
      sortable: true
    },
    {
      key: "TEC_FinalCustAccount_Name",
      label: "最终客户名称",
      sortable: true,
      thStyle: {
        width: "15rem"
      }
    },
    {
      key: "SEI_BigCustomerNumber",
      label: "TOP客户组",
      sortable: true,
      thStyle: {
        width: "10rem"
      },
      type: "short"
    },
    {
      key: "CurrencyCode",
      label: "币种",
      sortable: true
    },
    {
      key: "InclTax",
      label: "价格包括销售税",
      sortable: true
    },
    {
      key: "MainContactWorker",
      label: "销售经理",
      sortable: true
    },
    {
      key: "SEI_SalesGroup",
      label: "销售团队",
      sortable: true
    },
    {
      key: "SegmentId",
      label: "细分市场",
      sortable: true
    },
    {
      key: "description",
      label: "备注",
      sortable: true
    },
    {
      key: "create_by",
      label: "创建人",
      sortable: true,
      formatter: (value, key, item) => {
        return item.create_by_username
      }
    },
    {
      key: "create_at",
      label: "创建时间",
      sortable: true,
      type: "datetime"
    },
    {
      key: "update_by",
      label: "修改人",
      sortable: true,
      formatter: (value, key, item) => {
        return item.update_by_username
      }
    },
    {
      key: "update_at",
      label: "修改时间",
      sortable: true,
      type: "datetime"
    },

    {
      key: "SFApprover",
      label: "待审批人",
      sortable: true
    },

    {
      key: "fcCheckSFApproved",
      label: "订单审批",
      sortable: true,
      type: "state",
      state_control: "fcCheckSFApproved",
      context: ["待审批", "已审批"]
    },
    {
      key: "SFApprovedState",
      label: "订单审批状态名称",
      sortable: true,
      thStyle: {
        display: "none"
      },
      tdClass: "no-shown-RetailVariantId",
      formatter: (value, key, item) => {
        if (item.fcCheckSFApproved) {
          item.SFApprovedState = "已审批"
          return "已审批"
        }
        else if (item.is_email_send) {
          item.SFApprovedState = "审批中"
          return "审批中"
        }
        else {
          item.SFApprovedState = "待审批"
          return "待审批"
        }
      }
    },
    {
      key: "seq",
      label: "行号",
      sortable: true,
      width: "40px"
    },
    {
      key: "ItemId",
      label: "物料编号",
      sortable: true
    },
    {
      key: "NameAlias",
      label: "物料名称",
      sortable: true,
      type: "short",
      width: "10rem"
    },
    {
      key: "VariantName",
      label: "变型名称",
      sortable: true,
      type: "short",
      thStyle: {
        width: "8rem"
      }
    },
    {
      key: "SalesQty",
      label: "数量",
      sortable: true,

      type: "number"
    },
    {
      key: "StartDate",
      label: "装运日期",
      sortable: true,

      type: "date"
    },
    {
      key: "SalesUnitId",
      label: "单位",
      sortable: true
    },
    {
      key: "is_invent_ready",
      label: "备料",
      sortable: true,

      type: "boolean"
    },
    {
      key: "ModelId",
      label: "预测模型"
    },
    {
      key: "SEI_ForecastSalesType",
      label: "预测类型",

      type: "textarea"
    },
    {
      key: "SEI_ForecastAccuracy",
      label: "预测准确率(%)",

      type: "number"
    },
    {
      key: "item_description",
      label: "备注",
      sortable: true,

      type: "textarea"
    },
    {
      key: "RetailVariantId",
      label: "变形编号",
      sortable: true,
      //
      width: "8rem",
      thStyle: {
        display: "none"
      },
      tdClass: "no-shown-RetailVariantId"
    },
    {
      key: "SEI_DimensionFG",
      label: "FG维度",
      sortable: true
    },
    {
      key: "valid_remain",
      label: "剩余派发数量",
      sortable: true,
      type: "number"
    },
    {
      key: "SEI_CP_ReplenishmentCommit",
      label: "补货计划",
      sortable: true,
    },
    {
      key: "WeekName",
      label: "周的名称",
      sortable: true,
    },

    {
      key: "is_cancel",
      label: "取消",
      sortable: true,
      type: "boolean",
    },
  ]
}

///前端验证
const rules = {}

const descriptor = {}

const biz_data = new biz_data_helper.base_entity_helper(
  content_type,
  create,
  descriptor
)
const methods = {
  async getData(_params) {
    // console.log(_.map(fields.default, "key"));
    const code_biz_data = new biz_data_helper.base_entity_helper(
      "get_salesforecast_and_forecastline",
      {},
      {}
    )
    let _fields = []

    let result = await code_biz_data
      .execAction({
        params: _params,
        fields: _fields
      })
      .run()
    //
    if (
      result &&
      result[0].result &&
      result[0].result.data &&
      result[0].result.data.ActionResult &&
      result[0].result.data.ActionResult.Result &&
      result[0].result.data.ActionResult.Result.Data.length > 0
    ) {
      return result[0].result.data.ActionResult.Result.Data
    } else {
      return null
    }
  },
  ///取消
  async cancelData(_params, vm) {
    let item_biz_data = new biz_data_helper.base_entity_helper(
      "sPlant_OrderForecast_Line",
      create,
      descriptor
    )

    let _actions = []
    ///修改派单
    for (var i in _params.update_data) {
      _actions.push(
        item_biz_data
          .updateAction({
            params: _params.update_data[i],
            fields: ["id"]
          })
          .action({})
      )

    }
    ///调用ax接口
    if (!_.isNull(_params.ax_params)) {
      const h_biz_data = new biz_data_helper.base_entity_helper(
        "interface_invoke",
        {},
        {}
      )
      const x_biz_data = new biz_data_helper.base_entity_helper(
        "checkinterfaceresult",
        {},
        {}
      )
      _.each(_params.ax_params, t => {
        let _p = {
          company: t.company,
          method: "CMSalesForecast",
          jsonData: t.jsonData
        }
        if (t.jsonData.length > 0) {
          _actions.push(
            h_biz_data
              .handlerAction({
                params: _p
              })
              .action({
                output_last_item_map: {
                  status: "ax_interface_status"
                }
              })
          )
          _actions.push(
            x_biz_data
              .checkAction({
                params: {}
              })
              .action({
                rollback_when: {
                  ax_interface_status: {
                    "<>": 0
                  }
                }
              })
          )
        }
      })
    }

    let result = await api.query_batch({
      actions: _actions
    })

    if (
      result &&
      result.data &&
      result.data.BatchResult &&
      result.data.BatchResult.Actions &&
      result.data.BatchResult.Actions.length > 0
    ) {

      ///检查ax调用情况
      let _rt = _.filter(result.data.BatchResult.Actions, {
        Code: "data/x/checkinterfaceresult"
      })
      let _rdata = _.filter(result.data.BatchResult.Actions, {
        Code: "data/h/interface_invoke"
      })
      let _is_ok = true
      _.each(_rt, t => {
        if (t.Result && t.Result.Rollback == true) {
          _is_ok = false
        }
      })
      if (_is_ok == true) {
        return {
          state: true,
          data: result.data.BatchResult.Actions,
          message: ""
        }
      } else {
        let _msg = ""
        _.each(_rdata, t => {
          if (
            !_.isNull(t.Result) &&
            t.Result.LastItem.ax_interface_status != 0
          ) {
            _msg = vm.$t("notify.ax_error") + "：" + t.Result.Data[0][0].message
          }
        })
        return {
          state: false,
          data: [],
          message: _msg
        }
      }
    } else {
      return null
    }
  },
}
export { biz_data, fields, methods, rules };

